export default {
    MEETING_INVITE: 1,
    MEETING_CONFIRM_OR_REJECT: 2,
    NEW_ANSWER: 3, // this actually is both new answer and new question.  
    SILENT_UPDATE: 5,
    EVENT_MESSAGE: 6,
    CHAT_QUESTION: 4,
    NEW_CHAT_MESSAGE: 7,
    EVENT_ADDED: 8,
    NEW_QUESTION_ANSWER: 9,
    TASK_UPDATE: 10
};
